export default "__VITE_ASSET__C_gI3Dd3__"